import getSymbols from './internals/getSymbols.js';
import { objectKeys } from './internals/native.js';
import isObject from './isObject.js';

function allKeys(object) {
    if (!isObject(object)) {
        return [];
    }
    return objectKeys(object).concat(getSymbols(object));
}

export { allKeys as default };
